import type { ItemType } from '@/common/api/types/itemType';
import { ItemTypeIcon } from '@/common/components/ui/item-type/itemTypeIcon';
import { useItemPanelNavigation } from '@/features/item-panel/hooks/useItemPanelParams';
import { TabValue } from '@/features/item-panel/types';
import type { ItemsTableRow } from '@/features/items/components/table/types';

export const DependencyNameCell = ({
  row,
  itemTypes,
}: {
  row: ItemsTableRow;
  itemTypes: ItemType[];
}) => {
  const { openItemPanel } = useItemPanelNavigation();
  const itemType = itemTypes.find((type) => type.id === row.itemTypeId);
  return (
    <button
      type="button"
      onClick={() => openItemPanel({ itemId: row.id, panelTab: TabValue.DEPENDENCIES })}
      className="flex w-full min-w-0 cursor-pointer items-center gap-2 text-left hover:underline"
    >
      {!!itemType && <ItemTypeIcon itemType={itemType} />}
      <span className="flex-1 min-w-0 truncate font-medium leading-5 text-text-neutral-primary">
        {row.name}
      </span>
    </button>
  );
};
